var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"h-fade","mode":"out-in"}},[((!_vm.setIn && !_vm.isAlreadyIn) && _vm.indexPage())?_c('Index',{on:{"setInChange":_vm.goInto}}):_c('In')],1),_c('h-loading',{attrs:{"show":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }